import { useAtomValue, useStore } from 'jotai'
import { messageListRefAtom, resetAllAtoms } from './atom'
import { useEffect, useRef, useState } from 'react'

export function useScrollMessageListToBottom() {
  const store = useStore()

  return (smooth?: boolean) => {
    const messageListRef = store.get(messageListRefAtom)
    if (!messageListRef) return

    messageListRef.scrollTo({
      top: messageListRef.scrollHeight,
      behavior: smooth ? 'smooth' : 'auto',
    })
  }
}

export function useIsMessageListReachBottom() {
  const messageListRef = useAtomValue(messageListRefAtom)
  const [reachBottom, setReachBottom] = useState(true)
  useEffect(() => {
    if (!messageListRef) {
      setReachBottom(true)
      return
    }
    const handler = () => {
      if (
        messageListRef.scrollTop +
          messageListRef.clientHeight -
          messageListRef.scrollHeight >
        -200
      ) {
        setReachBottom(true)
      } else {
        setReachBottom(false)
      }
    }
    messageListRef.addEventListener('scroll', handler)

    return () => {
      messageListRef.removeEventListener('scroll', handler)
    }
  }, [messageListRef])

  return {
    reachBottom,
  }
}

/** 机器人回复消息过程中，监听用户列表滑动事件
 */
export function useListenUserTouchInMessage(
  isTyping: boolean,
  isTypingRef: React.MutableRefObject<boolean>
) {
  const messageListRef = useAtomValue(messageListRefAtom)
  const isUserTouchRef = useRef<boolean>(false)
  useEffect(() => {
    const handler = () => {
      if (!messageListRef) {
        isUserTouchRef.current = false
        return
      }
      if (
        messageListRef.scrollTop +
          messageListRef.clientHeight -
          messageListRef.scrollHeight >
        -10
      ) {
        // 脚本滑动
        isUserTouchRef.current = false
      } else {
        // 用户滑动
        isUserTouchRef.current = isTypingRef.current
      }
    }
    messageListRef?.addEventListener('scroll', handler)

    return () => {
      messageListRef?.removeEventListener('scroll', handler)
    }
  }, [messageListRef])
  useEffect(() => {
    if (isTyping) {
      isUserTouchRef.current = false
    }
  }, [isTyping])

  return { isUserTouchRef }
}

/**
 * 重置atom值
 * @returns
 * @description DS与4o共用，路由切换需要重置atom值
 */
export function useResetAtoms() {
  const store = useStore()
  return () => {
    resetAllAtoms(store)
  }
}
